module.exports = __webpack_public_path__ + "static/media/golive_white.dd86ecca.png";